/**
 * ============================================================
 *
 * [content]
 *
 * ============================================================
 */
// import * as azlib from '../global/azlib_light.bundle.js';
/**
 * 汎用JS クラス
 */
class ContentJS {
  constructor() {
    this.isSkip = false;
    this.isFlowAnime = false;
    this.isPopup = false;
    this.isOpen = false;
    this.isAllowClose = false;
    this.isDefaultFirst = true;
    this.isScroll = true;
    this.isNoCueOffset = false;
    this.hHeight = 0;
    this.hHeightOrg = 0;
    this.hWidth = 0;
    this.isNavMainHover = [];
    this.isNavSubHover = [];
    this.subHeights = [];
    this.resizeTimer = false;
    this.adminMargin = 0;
    // this.scrTopCache = 0;
    // ex
    this.mvSlider = null;
  }
  init() {
    this.isSkip = document.body.classList.contains('is-skip') ? true : false;
    this.isFlowAnime = document.body.classList.contains('is-flowAnime')
      ? true
      : false;
    this.isPopup = document.body.classList.contains('is-popup') ? true : false;
    this.isNoCueOffset = document.body.classList.contains('is-noCueOffset')
      ? true
      : false;
    // ロケーションハッシュ
    window.addEventListener('load', () => {
      if (location.hash !== '' && !this.isNoCueOffset) {
        const hash = location.hash.replace('#', '');
        const target = document.getElementById(hash);
        if (!target) return;
        this.hHeight = document.getElementById('siteHeader').clientHeight;
        const offset = -Number(this.hHeight);
        const targetPos =
          target?.getBoundingClientRect().top + window.pageYOffset + offset;
        new azlib.anime({
          targets: 'html, body',
          scrollTop: targetPos,
          duration: 10,
          easing: 'easeInQuad',
          complete: () => {
            const newTargetPos =
              target.getBoundingClientRect().top + window.pageYOffset + offset;
            // console.log(targetPos, newTargetPos)
            if (targetPos !== newTargetPos) {
              new azlib.anime({
                targets: 'html, body',
                scrollTop: newTargetPos,
                duration: 10,
                easing: 'linear',
              });
            }
          },
        });
      }
    });
    window.addEventListener('resize', () => {
      if (this.resizeTimer !== false) {
        clearTimeout(this.resizeTimer);
      }

      this.resizeTimer = setTimeout(() => {
        this.adjust();
        // if (!util.isRespMode) ScrollTrigger.refresh(true);
        if (util.isChangeMode) {
          window.location.reload();
          // if (!util.isRespMode) {
          //   document.getElementById('gNavWrapper').style.display = 'block';
          // } else {
          //   if (util.isNavOpen) document.getElementById('gNavWrapper').click();
          // }
        }
      }, 500);
    });
    if (document.getElementById('js-pageTopVox')) {
      document
        .querySelector('#js-pageTopVox button')
        .addEventListener('click', (e) => {
          document.documentElement.classList.remove('is-snap');
          new azlib.anime({
            targets: 'html, body',
            scrollTop: 0,
            duration: 500,
            delay: 200,
            easing: 'easeInOutQuart',
          });
        });
    }
    const focusLoop = new azlib.FocusLoop('#js-gNav');
    if (document.getElementById('gNavOpener')) {
      const opener = document.getElementById('gNavOpener');
      const content = document.getElementById('gNavWrapper');
      opener.setAttribute('aria-expanded', util.isRespMode ? false : true);
      content.setAttribute('aria-hidden', util.isRespMode ? true : false);
      if (util.isRespMode) {
        opener.addEventListener('click', (e) => {
          if (util.isNavOpen) {
            opener.classList.remove('is-navOpen');
            document.body.classList.remove('is-navOpen');
            opener.setAttribute('aria-expanded', false);
            content.setAttribute('aria-hidden', true);
            util.isNavOpen = false;
            focusLoop.isRun = false;
          } else {
            util.isNavOpen = true;
            focusLoop.isRun = true;
            opener.classList.add('is-navOpen');
            document.body.classList.add('is-navOpen');
            opener.setAttribute('aria-expanded', true);
            content.setAttribute('aria-hidden', false);
          }
        });
      }
    }
    document.querySelectorAll('#gNavWrapper a').forEach((v, i) => {
      v.addEventListener('click', (e) => {
        if (util.isNavOpen) document.getElementById('gNavOpener').click();
      });
    });
    this.hHeightOrg = document.getElementById('siteHeader')
      ? document.getElementById('siteHeader').clientHeight
      : 0;
    const rplSPImg01 = new azlib.ReplaceImageSP('.rplSPImg', {
      spBreakPoint: util.spBreakPoint,
    });
    // if (this.isPopup) {
      const popup = new azlib.PopupAdjust('.popupBtItem', {
        isAdjust: false,
        isA11y: false,
        onComplete: () => {
          console.log('loaded');

          document.querySelectorAll('.popupBtItem.img').forEach((v, i) => {
            v.addEventListener('click', (e) => {
              document.querySelector('#popupWrapperImg .content').innerHTML =
                '';
              const img = v.getAttribute('data-img');
              const imgSP = v.getAttribute('data-img-sp');
              const src = `
                <picture>
                  <source media="(max-width: 767px)" srcset="${imgSP}" width="320" height="600">
                  <img src="${img}" alt="" width="1100" height="650">
                </picture>
              `;
              document
                .querySelector('#popupWrapperImg .content')
                .insertAdjacentHTML('beforeend', src);
            });
          });
          // document.querySelectorAll('.popupBtItem.img')[0].click();
        },
      });
      document.querySelectorAll('.popupBtItem.movie').forEach((v, i) => {
        v.addEventListener('click', (e) => {
          const movie = v.getAttribute('data-movie');
          const src = `<iframe src="https://www.youtube.com/embed/${movie}?autoplay=1&rel=0" frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
          document
            .querySelector('#popupWrapperMovie .content')
            .insertAdjacentHTML('beforeend', src);
        });
      });
    // }
    if (this.isFlowAnime) {
      // flowVox
      const flowVox = new azlib.FlowVox('.flowVox', {
        // isRepeat: true,
        // per: 0.25,
        translate: 20,
        duration: 700,
        easing: 'easeOutCubic',
      });
    }
    const acc01 = new azlib.SimpleAccordion();
    // gsap.to(window, { duration: 0.1, scrollTo: "#wrapper" });
    // this.adjust().then(() => this.runIntro());
  }
  async adjust() {
    new Promise((resolve, reject) => {
      this.hHeight = document.getElementById('siteHeader').clientHeight;
      this.adminMargin = parseInt(
        getComputedStyle(document.getElementsByTagName('html')[0]).marginTop
      );
      // util.sScroll(
      //   -(Number(this.adminMargin) + Number(this.hHeight)),
      //   1000,
      //   'easeOutQuad',
      //   'a[href*="#"].scroll, area[href*="#"].scroll',
      //   true
      // );
      this.adjustHeader();
      return 'resolve';
    });
  }
  runIntro() {
    if (this.isSkip) return;

    // document.getElementById('wrapper').style.visibility = 'visible';

    new azlib.anime({
      targets: '#loading',
      opacity: [1, 0],
      complete: (anim) => {
        if (document.getElementById('loading')) {
          document.getElementById('loading').style.display = 'none';
        }
      },
    });

    new azlib.anime({
      targets: '#wrapper',
      opacity: 1,
      delay: 450,
      duration: 350,
      easing: 'linear',
      complete: (anim) => {
        this.isDefaultFirst = false;
        document.body.classList.add('is-finishedIntro');
      },
    });
  }
  adjustHeader() {}
}
class MV {
  constructor() {
    this.wrapper;
    this.elem;
    this.size = {};
    this.movePer = {};
    this.resizeTimer = false;
  }
  init() {
    this.loadImages();
    this.wrapper = document.getElementById('js-mvListWrapper');
    this.elem = document.getElementById('js-mvList');

    this.setMovePer();
    console.log(this.movePer);
    this.adjust();

    window.addEventListener('resize', () => {
      if (!util.isRespMode) {
        if (util.isChangeWIWidth || util.isChangeWIHeight) {
          window.location.reload();
        }
      }
    });

    this.wrapper.classList.remove('is-loading');

    this.run();
  }
  run() {
    const tl = gsap.timeline({
      repeat: -1,
      defaults: {
        ease: 'linear',
      },
    });
    const movePer = util.isRespMode ? this.movePer.sp : this.movePer.pc;

    tl.to(this.elem, { // 斜め SP PC
      x: `+=${movePer.x}`,
      y: `+=${movePer.y}`,
      duration: util.isRespMode ? 14 : 8,
    });
    tl.to(this.elem, { // 横
      x: `-=${movePer.x}`,
      duration: util.isRespMode ? 12 : 8,
    });
    tl.to(this.elem, { // 斜め
      x: `+=${movePer.x}`,
      y: `-=${movePer.y}`,
      duration: util.isRespMode ? 14 : 8,
    });
    tl.to(this.elem, { // 横
      x: `-=${movePer.x}`,
      duration: util.isRespMode ? 12 : 8,
    });
  }
  getMovePer() {
    this.size = {
      w1: this.wrapper.clientWidth,
      w2: this.elem.clientWidth,
      h1: this.wrapper.clientHeight,
      h2: this.elem.clientHeight,
    };

    return {
      pc: {
        x: (this.size.w2 - this.size.w1) / 5,
        y: (this.size.h2 - this.size.h1) / 8,
      },
      sp: {
        x: (this.size.w2 - this.size.w1) / 2.5,
        y: (this.size.h2 - this.size.h1) / 4,
      },
    };
  }
  setMovePer() {
    const obj = this.getMovePer();
    this.movePer = obj;
  }
  adjust() {
    const ratio = (() => {
      if (util.wWidth > util.wHeight) {
        return util.wIWidth / this.size.w1;
      } else {
        return util.wIHeight / this.size.h1;
      }
      // return util.wHeight / this.size.h1;
    })();
    console.log(ratio);
    Object.assign(this.wrapper.style, {
      transformOrigin: 'left top',
      scale: `${ratio}`,
    });

    if (
      util.wIHeight > document.getElementById('mainVisualWrapper').clientHeight
    ) {
      document.getElementById(
        'mainVisualWrapper'
      ).style.height = `${util.wIHeight}px`;
    }
  }
  removeCircle() {
    this.elem.querySelectorAll('.circle').forEach((v) => v.remove());
  }
  loadImages() {
    let images = [];
    for (let i = 1; i <= 20; i++) {
      const num = i.toString().padStart(2, '0');
      images.push(
        `https://cdn.shopify.com/s/files/1/0728/7780/1785/files/calula_scene_popup${num}${
          util.isRespMode ? '-sp' : ''
        }.png`
      );
    }
    new util.loadImages(images);
  }
}
/**
 * インスタンス化
 */
const util = new azlib.Utilities({
  spBreakPoint: 768,
});
const contentJS = new ContentJS();
const mvJS = new MV();
/**
 * 実行
 */
window.addEventListener('DOMContentLoaded', () => {
  util.init();
  contentJS.init();
  const lazyBg = new azlib.LazyLoadBg('.js-lazyBg');
  mvJS.init();
});

/* アンカーリンク ヘッダー高さ 調整 */
document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('siteHeader');
  // アンカーリンクのクリックイベント
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      e.preventDefault(); // デフォルトの動作を防ぐ
      const targetId = anchor.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        const headerHeight = header.offsetHeight; // ヘッダーの高さを取得
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        // スクロール位置を調整して移動
        window.scrollTo({
          top: targetPosition - headerHeight,
          behavior: 'smooth'
        });
      }
    });
  });
  // ページ読み込み後にURLにハッシュがある場合
  if (window.location.hash) {
    const targetId = window.location.hash.substring(1);
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const headerHeight = header.offsetHeight; // ヘッダーの高さを取得
      const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
      // スクロール位置を調整して移動
      window.scrollTo({
        top: targetPosition - headerHeight,
        behavior: 'smooth'
      });
    }
  }
});

/* アニメーション クラス付与 */
$(this).scrollTop(1);
$(window).on('scroll', function () {
  var class_set01 = $('.ani_trigger');
  var isAnimate = 'anime_active';

  class_set01.each(function () {
    var classOffset = $(this).offset().top;
    var scrollPos = $(window).scrollTop();
    var wh = $(window).height();
    var ch = $(this).height();
    if (scrollPos > classOffset - wh + wh / 3) {
      $(this).addClass(isAnimate);
    }
    /*
		if(scrollPos > classOffset + ch){
			$(this).removeClass(isAnimate);
		}
		*/
  });
});
